@if (fieldFormControl()) {
  <mat-slide-toggle
    disableRipple
    class="u-toggle-switch {{ styleClass() }}"
    [disabled]="stateElement() === 'disabled'"
    [formControl]="fieldFormControl()"
  >
  </mat-slide-toggle>
} @else {
  <mat-slide-toggle
    disableRipple
    class="u-toggle-switch {{ styleClass() }}"
    [disabled]="stateElement() === 'disabled'"
    [checked]="checked()"
    (change)="onChange.emit($event)"
  >
  </mat-slide-toggle>
}
